import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TableRow, TableHeader, Table, TableHeaderColumn, TableBody, TableRowColumn, Checkbox } from 'material-ui';
import { ifElse, not, isNil, isEmpty, either, equals, path, contains } from 'ramda';
import { checkConnection, uncheckConnection } from '../../../../stores/marketing-materials/actions';
import ProfileImage from '../../../app-bar/profile-image';
import Pagination from '../../../tc-ui/pagination/pagination';


const isNilOrEmpty = either(isNil, isEmpty);

class TableContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      filteredConnections: [],
      existingConnections: [],
      selectedExistingPartners: [],
      searchField: '',
    };
  }
  componentDidMount() {// workaround the component not getting prop upates because being in the background
    this.componentWillReceiveProps(this.props);
  }
  componentWillReceiveProps(nextProps) {
    // sync stated objects (there are two possible sources)
    const { filteredConnections, existingConnections, selectedExistingPartners, searchField } = (isEmpty(nextProps.MMPartnerReducer2) ?
    nextProps.MMPartnerReducer : nextProps.MMPartnerReducer2); // fallback to reducer

    if (!equals(this.state.filteredConnections, filteredConnections)) {
      this.setState({ filteredConnections, currentPage: 1 });
    }
    if (!equals(this.state.existingConnections, existingConnections)) {
      this.setState({ existingConnections, currentPage: 1 });
    }
    if (!equals(this.state.selectedExistingPartners, selectedExistingPartners)) {
      this.setState({ selectedExistingPartners });
    }
    if (!equals(this.state.searchField, searchField)) {
      this.setState({ searchField });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !equals(this.state, nextState);
  }
  switchPage = (newPage) => {
    this.setState({ currentPage: newPage });
  }
  render() {
    const check = isEmpty(this.props.MMPartnerReducer2) ? this.props.check : this.props.MMPartnerReducer2.check; // fallback to reducer
    const uncheck = isEmpty(this.props.MMPartnerReducer2) ? this.props.uncheck : this.props.MMPartnerReducer2.uncheck; // fallback to reducer
    const { selectedExistingPartners, currentPage, filteredConnections, searchField, existingConnections } = this.state;

    const selectAllCheck = not(isNilOrEmpty(filteredConnections)) ?
      equals(selectedExistingPartners.length, filteredConnections.length)
      : equals(selectedExistingPartners.length, existingConnections.length);

    const rows = not(isNilOrEmpty(filteredConnections)) || not(isNilOrEmpty(searchField)) ? filteredConnections : existingConnections;
    return (
      <Table multiSelectable style={{ borderBottom: '1px solid #e0e0e0' }} selectable={false}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn style={{ width: '30px' }}>
              <Checkbox
                onCheck={ifElse(
                  () => selectAllCheck,
                    () => uncheck({ checkType: 'uncheckAll' }),
                  () => check({ checkType: 'checkAll' })
                )}
                checked={selectAllCheck}
              />
            </TableHeaderColumn>
            <TableHeaderColumn style={{ width: '80px' }}/>
            <TableHeaderColumn>Company Name</TableHeaderColumn>
            <TableHeaderColumn>Email</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {rows.slice(((currentPage - 1) * 5), ((currentPage - 1) * 5) + 5).map((partner, i) => (
            <TableRow key={i} style={{ height: '32px' }}>
              <TableRowColumn style={{ width: '30px' }}>
                <Checkbox
                  onCheck={ifElse(
                    () => contains(partner, selectedExistingPartners),
                      () => uncheck({ checkType: 'uncheckOne', partner }),
                    () => check({ checkType: 'checkOne', partner })
                  )}
                  checked={contains(partner, selectedExistingPartners)}
                />
              </TableRowColumn>
              <TableRowColumn style={{ height: '32px', fontSize: '14px', width: '80px' }}>
                <ProfileImage
                  className="profile-link-image connections-profile-link-image"
                  companySlugName={partner.companyName}
                  email={partner.email}
                  imageUrl={partner.profileImageUrl}
                />
              </TableRowColumn>
              <TableRowColumn style={{ height: '32px', fontSize: '14px' }}>
                {partner.companyName}
              </TableRowColumn>
              <TableRowColumn style={{ height: '32px', fontSize: '14px' }}>
                {partner.email}
              </TableRowColumn>
            </TableRow>
            ))
          }
          <TableRow selectable={false}>
            <TableRowColumn colSpan={4}>
            {rows.length > 5 ? <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(rows.length / 5)}
              goToPage={this.switchPage}
              noOfPagesToShow={5}
            /> : undefined }
            </TableRowColumn>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
}

TableContainer.propTypes = {
  MMPartnerReducer: PropTypes.object,
  MMPartnerReducer2: PropTypes.object,
  check: PropTypes.func,
  uncheck: PropTypes.func,
  check2: PropTypes.func,
  uncheck2: PropTypes.func,
};

TableContainer.defaultProps = {
  MMPartnerReducer2: {},
};

const mapDispatchToProps = dispatch => ({
  check: (...args) => dispatch(checkConnection(...args)),
  uncheck: (...args) => dispatch(uncheckConnection(...args)),
});

const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableContainer);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/existing/table.jsx